import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useEffect, useState } from 'react';
import { PipelinesCache } from '../PipelinesCache';
import { useHttpClient } from '../../client/HttpClientContext';
import I18n from 'I18n';
const cache = new PipelinesCache();

const shouldUpdateClosedate = ({
  currentStage,
  nextStage
}) => {
  if (!currentStage.metadata || !currentStage.metadata.probability) {
    return false;
  }

  if (!nextStage.metadata || !nextStage.metadata.probability) {
    return false;
  }

  const currentStageProbability = Number(currentStage.metadata.probability);
  const nextStageProbability = Number(nextStage.metadata.probability);

  if ([0, 1].includes(nextStageProbability) && currentStageProbability !== nextStageProbability) {
    return true;
  }

  return false;
};

export const useGetClosedateForDealObjects = ({
  objectTypeId
}) => {
  const shouldCheckClosedateLogic = objectTypeId === DEAL_TYPE_ID;
  const [loading, setLoading] = useState(shouldCheckClosedateLogic);
  const [pipelines, setPipelines] = useState({});
  const httpClient = useHttpClient();
  useEffect(() => {
    if (!shouldCheckClosedateLogic) {
      setPipelines({});
      setLoading(false);
      return;
    }

    cache.get({
      objectTypeId,
      httpClient
    }).then(pipelinesForObjectType => {
      setPipelines(pipelinesForObjectType);
      setLoading(false);
    }).catch(__err => {
      //Todo: Sentry once Raven is setup in CDP
      // We are not failing rendering in case of a pipeline stage fetch error. We are simply not doing the closedate pre-fill
      setPipelines({});
      setLoading(false);
    });
  }, [httpClient, objectTypeId, shouldCheckClosedateLogic]);
  const getClosedateForDealObjects = useCallback(({
    currentPipelineId,
    nextPipelineId,
    currentStageId,
    nextStageId
  }) => {
    if (!shouldCheckClosedateLogic) {
      return '';
    }

    if (!currentPipelineId || !pipelines[currentPipelineId] || !nextPipelineId || !pipelines[nextPipelineId]) {
      return '';
    }

    const currentPipelineStages = pipelines[currentPipelineId].stages;
    const nextPipelineStages = pipelines[nextPipelineId].stages;
    const currentStage = currentPipelineStages && currentPipelineStages.find(stage => stage.stageId === currentStageId);

    if (!currentStage) {
      return '';
    }

    const nextStage = nextPipelineStages && nextPipelineStages.find(stage => stage.stageId === nextStageId);

    if (!nextStage) {
      return '';
    }

    if (shouldUpdateClosedate({
      currentStage,
      nextStage
    })) {
      return `${I18n.moment.userTz().valueOf()}`;
    }

    return '';
  }, [pipelines, shouldCheckClosedateLogic]);
  return {
    loading,
    getClosedateForDealObjects
  };
}; // exported for unit test usage only

export const _resetCache = () => {
  cache.clear();
};